<template>
  <div>
    <div class="paybox" id="qrcode" ref="qrcode"></div>
  </div>
</template>

<script>
import QRCode from 'qrcodejs2'
export default {
  data(){
    return{
      qrcodeList:["1","2","3"],
      num:0,
    }
  },
  methods:{
    changeQrcode(){
      let that = this
      var cal_arr = document.getElementById("qrcode").getElementsByTagName("img")
      cal_arr = Array.from(cal_arr);
      cal_arr.forEach(item => {
        if (item.nodeName.toLowerCase() === 'img') {//我的数据返回是可以
          document.getElementById("qrcode").removeChild(item)
        }
      })
      console.log(cal_arr)
      console.log(this.num)
      this.$nextTick(() => {
        this.qrcode = new QRCode("qrcode", {
          width: 200,//二维码宽度
          height: 200,//二维码高度
          text: that.qrcodeList[that.num],//调用微信支付接口返回的微信特殊链接：例如"weixin://wxpay/bizpayurl?pr=uDKsQ4E00"
          colorDark: "#000",//颜色配置
          colorLight: "#fff",
        });
        if(that.num==that.qrcodeList.length-1){
          that.num=0
        }else{
          that.num++
        }
      });
      setTimeout(()=>{
        that.changeQrcode()
      },5000)
    },
  },
  mounted(){
    this.changeQrcode()
  }
}
</script>

<style scoped>
.paybox{
  width: 200px;
  height: 200px;
}
</style>